import { render, staticRenderFns } from "./cardsUser.vue?vue&type=template&id=ffb80b34&"
import script from "./cardsUser.vue?vue&type=script&lang=js&"
export * from "./cardsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports